module.exports = __webpack_public_path__ + "img/swiper1.dc6f224a.jpg";